import { render, staticRenderFns } from "./AyudaTrasladoCosecha.vue?vue&type=template&id=28b1d3f8&scoped=true"
import script from "./AyudaTrasladoCosecha.vue?vue&type=script&lang=js"
export * from "./AyudaTrasladoCosecha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1d3f8",
  null
  
)

export default component.exports